﻿import { defineComponent } from 'vue';

import itinerary_breakdown from "../common/itinerary_breakdown.vue"
import trip_summary from "../common/trip_summary.vue"

import { Booking } from "../../../services/booking";
import { Date_Service } from "../../../../system/services/date_service";
import { Currency_Service } from "../../../../system/services/currency";
import { request_payment_initialise_internal } from "../../../objects/v1_3/payment/initialise/request_payment_initialise_internal";

const Book: Booking = new Booking();
const Currency_Services: Currency_Service = new Currency_Service();
const Date_Services: Date_Service = new Date_Service();

export default defineComponent({
    name: "summary",
    components: {
        itinerary_breakdown,
        trip_summary
    },
    props: {
    },
    data() {
        return {
        }
    },
    methods: {
        GetBrand(): string {
             return String(import.meta.env.VITE_DEFAULT_CLASS);
        },
        get_balance_outstanding_formatted(): string {
            return Currency_Services.Format_Currency(Book.get_total_outstanding(this.$store.getters.get_Booking), this.$store.getters.get_Currency);
        },
        get_balance_outstanding(): number {
            return Book.get_total_outstanding(this.$store.getters.get_Booking);
        },
        has_balance_outstanding(): boolean {
            return Book.get_total_outstanding(this.$store.getters.get_Booking) > 0;
        },
        Balance_Due_Date(): string {
            return Date_Services.full_date(Book.get_Expiry_Date(this.$store.getters.get_Booking));
        },
        get_Currency(): string {
            return this.$store.getters.get_Currency.currency_info.iso_currency_code;
        },
        get_Total_Price(): string {
            return Currency_Services.Format_Currency(Book.get_total_price(this.$store.getters.get_Booking, this.$store), this.$store.getters.get_Currency);
        },
        get_payment_amount() : number {
            let payment_session = this.$store.getters.get_Payment_Session;
            return payment_session?.payment_initialise.amount ? payment_session?.payment_initialise.amount : this.get_balance_outstanding();
        },
        redirect_to_paymentpage(amount: number) {
            if (amount == 0) {
                amount = this.get_balance_outstanding();
            }

            let payment_session : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            if (payment_session && payment_session != null) {
                payment_session.payment_initialise.amount = amount;
                payment_session.payment_initialise.payments = null;
                this.$store.commit('Payment_Session', { Payment_Session: payment_session });
            }

            this.$router.push({ path: "/creditcard" });
        },
        get_Departure_Date(): string {
            return Date_Services.output_date(this.$store.getters.get_Booking?.trips[0].departure_date);
        },
        get_tourIds(): string {
            const booking = this.$store.getters.get_Booking;
            if (!booking || !Array.isArray(booking.trips)) {
            return "";
            }
            let tourIds = booking.trips
            .filter((trip: any) => trip && trip.tour_id)
            .map((trip: any) => trip.tour_id)
            .join(",");

            //META PIXEL CONDITIONS
            // This should be removed once the new system dashboard is created
            let winterTourIds = ["I3B", "ABE", "X5P", "3H1", "H52"];
            if (winterTourIds.some(id => tourIds.toUpperCase().includes(id))) {
                tourIds += ",WINTER_TOUR_PURCHASE";
            }

            let dateSpecificWinterTourIds = ["IV6", "HXN", "IV5", "OT1", "HXF"];
            const hasDateSpecificWinterTour = dateSpecificWinterTourIds.some(id => tourIds.toUpperCase().includes(id));
            if (hasDateSpecificWinterTour) {
                const departureDateStr = this.get_Departure_Date?.() ?? "";

                const parseYMD = (str: string): Date | null => {
                    const m = /^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})$/.exec(str.trim());
                    if (!m) return null;
                    const y = Number(m[1]);
                    const mo = Number(m[2]) - 1;
                    const d = Number(m[3]);
                    const dt = new Date(y, mo, d);
                    if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) return null;
                    return dt;
                };

                const departureDate = departureDateStr ? parseYMD(departureDateStr) : null;

                if (departureDate) {
                    const month = departureDate.getMonth();
                    const isWinterWindow = month === 10 || month === 11 || month === 0 || month === 1 || month === 2;
                    if (isWinterWindow) {
                        tourIds += ",WINTER_TOUR_PURCHASE";
                    }
                }
            }

            
            return tourIds;
        },
        redirect_with_tourIds() {
            const tourIds = this.get_tourIds();
            const currentPath = this.$route.path;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    ...(tourIds ? { tours: tourIds } : {})
                }
            });
        },
        Get_Paid(): number {
            return Book.get_Paid(this.$store.getters.get_Booking);
        },
        is_fully_paid(): boolean {
            return !this.has_balance_outstanding();
        },
        is_part_paid(): boolean {
            return this.Get_Paid() > 0 && this.has_balance_outstanding();
        },
        is_not_paid(): boolean {
            return this.Get_Paid() === 0 && this.has_balance_outstanding();
        },
    },
    mounted() {
        this.redirect_with_tourIds();
    }
})